import React from 'react'
import { Button } from 'hhsoig-design-system-core'
import { Divider } from '../../components/divider'
import { routePaths as routes } from '../../utilities/routePaths'
import { withDocTitle } from '../../components/withDocTitle'
import css from './confirmation.module.css'

export class Confirmation extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <React.Fragment>
        <main data-testid="complaint-confirmation">
          <h1>Confirmation</h1>
          <p>You have successfully submitted your complaint.</p>
          {this.props.location &&
            this.props.location.search
              .toLowerCase()
              .includes('retaliated-against=true') && (
              <p>
                Based on your response, you may be a victim of whistleblower
                retaliation. Read more about{' '}
                <a
                  href="https://oig.hhs.gov/fraud/report-fraud/whistleblower.asp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  whistleblower protection information
                </a>{' '}
                and{' '}
                <a
                  href="https://oig.hhs.gov/fraud/report-fraud/eligibility.asp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  check your eligibility.
                </a>
                <Button
                  variation="primary"
                  data-testid="confirm-whistleblower"
                  href={routes.whistleblower.base}
                >
                  Report whistleblower retaliation
                </Button>
              </p>
            )}

          <p>
            Thank you for your submission. Hotline tips are incredibly valuable,
            and we appreciate your efforts to help us stamp out fraud, waste,
            and abuse.
          </p>
          <p>
            We will review your complaint for relevance and completeness. If you
            have identified yourself, a reviewing official may contact you for
            further information. It is important to note that you may not be
            contacted by an investigator but that does not mean your complaint
            is not being investigated. Due to the high volume of complaints we
            receive, it is not possible to contact every complainant. The
            Hotline will not be able to confirm receipt of your complaint or
            respond to any inquiries about action taken on your complaint.
          </p>
          <p>
            You may request information about your complaint through the
            {` `}
            <a href="https://oig.hhs.gov/foia">
              OIG Freedom of Information Act
            </a>
            {` `}
            office. Remember to phrase your request in terms of a search for
            records pertinent to your complaint, not status. You should wait at
            least six months before filing such a request.
          </p>
          <Button
            variation="secondary"
            data-testid="confirm-complaint"
            href="https://oig.hhs.gov/fraud/report-fraud/index.asp"
            className={css.buttonSpacing}
          >
            Return to HHS-OIG Hotline
          </Button>
          {this.props.showFeedback ? (
            <React.Fragment>
              <Divider />
              <h2>Share your feedback, help us improve</h2>
              <p>
                We have launched our new complaint forms, and would appreciate
                your feedback. Please tell us about your experience and provide
                any recommendations on how we can improve the website. Thank you
                for taking the time to help us improve our complaint process.
              </p>
              <Button
                variation="primary"
                data-testid="feedback-form"
                onClick={() => this.props.history.push(routes.feedback.form)}
                className="ds-u-margin-bottom--2 ds-u-margin-top--2"
              >
                Share feedback
              </Button>
            </React.Fragment>
          ) : (
            ''
          )}
        </main>
      </React.Fragment>
    )
  }
}

export default withDocTitle(Confirmation)
